module.exports = __webpack_public_path__ + "img/ic-help-toc-pos.69616b4a.svg";